import {Box, HBox} from '../../../components/core/view';
import {useColorThemeType, useFontTheme} from '../../../appStyles/hooks/theme';

import {H3Text} from '../../../components/core/text';
import {Modules} from '@buncha/utils/types';
import PaperBag from '../../../components/core/icon/PaperBag';
import React from 'react';
import {ShopperScreens} from '@buncha/home/navigation/types';
import {styles} from './styles';
import {useGetLocale} from '@buncha/localization/hooks';

function EmptyTodo() {
  const mortiseFont = useFontTheme('mortise');
  const theme = useColorThemeType();
  const {title} =
    useGetLocale(Modules.batchDetails, ShopperScreens.BatchDetailsPage) ?? {};
  return (
    <Box style={[styles.mainContainer]}>
      <HBox style={[styles.iconContainer]}>
        <PaperBag
          height={150}
          width={87}
          fill={theme?.background.blue[300]}
          viewBox="0 0 112 120"
        />
      </HBox>
      <H3Text
        style={[
          styles.text,
          {
            fontFamily: mortiseFont[700].normal,
            color: theme?.text.blue[300],
          },
        ]}>
        {title?.shopCompleted}
      </H3Text>
    </Box>
  );
}

export default React.memo(EmptyTodo);
